import * as a from '../actions/exchangeRate'
import { createReducer } from 'redux-act'

let DEFAULT_STATE = {
    curentExchangeRate : 0,
}
export default createReducer(
    {
        [a.fetchExchangeRateSuccessful]: (state, payload) => {
            return {
                ...state,
                curentExchangeRate: payload.currentExchangeRate
            }
        },
        [a.fetchExchangeRateFailure]: (state, payload) => {
            return {
                ...state
            }
        },
    },
    DEFAULT_STATE
);